import { t } from 'i18next';
import * as yup from 'yup';

import { UpsertPartBomCreateType } from 'partBoms/components/UpsertPartBom';
import { PartBomType } from 'partBoms/enums';

export const partBomUpsertDetailsSchema = () =>
  yup.object().shape({
    bomType: yup
      .string()
      .label(t('labelPartBomType'))
      .nullable()
      .oneOf(Object.values(PartBomType))
      .required(),
    createType: yup
      .string()
      .label(t('labelPartBomCreateType'))
      .oneOf(Object.values(UpsertPartBomCreateType))
      .nullable()
      .required(),
    sourcePartBom: yup
      .object()
      .label(t('labelPartBom'))
      .nullable()
      .when('createType', {
        is: UpsertPartBomCreateType.EXISTING,
        then: (schema) => schema.nullable().required(t('errorPartBomSourceRequired')),
        otherwise: (schema) => schema.nullable(),
      }),
    number: yup.string().label(t('labelPartBomNumber')).nullable().required(),
    description: yup.string().label(t('labelPartBomDescription')).nullable().required(),
    uom: yup.string().label(t('labelPartBomUom')).nullable().required(),
  });
